module.exports = __webpack_public_path__ + "static/media/icon-search-dark.e281c84b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-search-dark.svg
// module id = 1471
// module chunks = 0